var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-container',{class:_vm.classes,scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('g-footer',{on:{"change":_vm.onChangeLocale}})]},proxy:true}])},[(_vm.isUserAgreementAndResetPassword)?_c('page-content'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4795cd23","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/PageLayout.vue
// module id = null
// module chunks = 